module.exports = __webpack_public_path__ + "static/media/170.ad0ff51c.webp";